import React                     from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import TimecardTestListView      from './TimecardTestListView';
import timecardTestPageModel     from './TimecardTestPageModel';
import TimecardTestToolbar       from './TimecardTestToolbar';
import TimecardTestView          from './TimecardTestView';
import { withStyles }            from '../utility/styles';


const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  timecardTestView: {
    display: 'flex',
    flex: '1',
    flexDirection: 'row',
    overflowY: 'auto',
  },
});

interface ITimecardTestPageViewProps {
}

type TimecardTestPageViewProps = WithStyle<ReturnType<typeof styles>, ITimecardTestPageViewProps>;

class TimecardTestPageView extends React.PureComponent<TimecardTestPageViewProps> {
  constructor(props: TimecardTestPageViewProps) {
    super(props);
  }

  componentWillUnmount() {
    timecardTestPageModel.reset();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Observe render={() => (
          < >
          <TimecardTestToolbar />
          <div className={classes.timecardTestView}>
            <TimecardTestListView />
            <TimecardTestView />
          </div>
          </>
        )} />
      </div>
    );
  }
}

export default withStyles<ITimecardTestPageViewProps>(styles, TimecardTestPageView);
